import { GetMetadataReplyV1 } from "./Interfaces/LSS/GetMetadataReplyV1";
import * as JSONBig from 'json-bigint'
export class Helper {
  /**
   * Performs a diff operation to get the delta of files present in local but not in remote
   * @param localFiles - Files present in local CL folder
   * @param childrenMetadata - Metadata od the files present in remote CLIS server
   */
  public static getFilesToDelete(
    localFiles: string[],
    childrenMetadata: GetMetadataReplyV1
  ): string[] {
    const filesToDelete = new Array<string>();
    if (
      childrenMetadata == null ||
      childrenMetadata.metadataArray == null ||
      childrenMetadata.metadataArray.length == 0
    )
      return localFiles;
    if (localFiles == null || localFiles.length === 0) return filesToDelete;

    for (const file of localFiles) {
      if (!childrenMetadata.metadataArray.find(rm => rm.name === file)) {
        filesToDelete.push(file);
      }
    }
    return filesToDelete;
  }

  /**
   * Compares the local and remote metadata to see if file has been updated since last sync.
   * This method will only return true if the metadata for the object exists for both local and remote,
   * and the last modified timestamp has not changed. For all other cases (include null or falsy
   * values at either end) it returns false.
   *
   * @param localMetadata
   * @param remoteMetadata
   */

  public static compareLastModified(
    localMetadata: GetMetadataReplyV1,
    remoteMetadata: GetMetadataReplyV1
  ): boolean {
    if (localMetadata == null || remoteMetadata == null) {
      return false;
    }

    if (
      !localMetadata.metadataArray ||
      !localMetadata.metadataArray.length ||
      !remoteMetadata.metadataArray ||
      !remoteMetadata.metadataArray.length
    ) {
      return false;
    }

    const localMd = localMetadata.metadataArray[0];
    const remoteMd = remoteMetadata.metadataArray[0];

    return localMd.lastModified.toString() === remoteMd.lastModified.toString();
  }

  /**
   * Parses JSON string containing arbritarily large numbers without
   * loss of precision.
   *
   * @param jsonString
   */
  public static parseJSON(jsonString: string): any {
      const jsonObj = JSONBig.parse(jsonString);
      return jsonObj;
  }

  /**
   * Handles the conversion of JSON objects containing BigNumber values into
   * valid JSON strings.
   *
   * @param jsonObject
   */
  public static stringifyJSON(jsonObject: any): string {
      const jsonString = JSONBig.stringify(jsonObject);
      return jsonString;
  }

  /**
   * Checks if given object is a valid GetMetadataReplyV1 object
   * A valid GetMetadataReplyV1 object is a list of metadata entries
   * @param jsonObject
   * @returns whether given json object is a valid GetMetadataReplyV1
   */
  public static isValidMetadataReply(jsonObject: any): boolean {
	  return (
	    jsonObject != null &&
	    jsonObject.metadataArray != null &&
	    jsonObject.metadataArray.length != 0
	  );
  }
}
